module.exports = __webpack_public_path__ + "static/media/pic06.1d66343a.svg";